import { createEntityAdapter } from '@reduxjs/toolkit'

import { PlanningShiftTable } from '../model/planning/PlanningShiftTable'

export const planningShiftTablesAdapter = createEntityAdapter({
  selectId: (table: PlanningShiftTable) => table.shiftId,
})
